import React from 'react';
import classNames from 'classnames';
import path from 'path';
import api from 'api';
import { AppLink } from '../modules/routing/containers';

class SettingsMenu extends React.Component {
  constructor(props) {
    super(props);
    this.isActive = this.isActive.bind(this);
  }
  render() {
    const root = '/settings';
    return (
      <ul className="sidebar-menu">
        <li className={ classNames({ active: this.isActive('/global-settings') }) }>
          <AppLink to="/global-settings" customRoot={ root }><i className="fas fa-sliders-h fa-fw"></i> <span>Global settings</span></AppLink>
        </li>
        <li className={ classNames({ active: this.isActive('/user-settings') }) }>
          <AppLink to="/user-settings" customRoot={ root }><i className="fas fa-user-circle fa-fw"></i> <span>User settings</span></AppLink>
        </li>
        {
          this.props.currentUser.group.name === 'admin'
            ? <li className={ classNames({ active: this.isActive('/users') }) }>
                <AppLink to="/users" customRoot={ root }>
                  <i className="fas fa-users fa-fw"></i> <span>Users</span>
                </AppLink>
              </li>
            : null
        }
      </ul>
    );
  }

  isActive(url) {
    const [pathname, searchParams] = url.split('?');
    return this.props.location.pathname.match(`^${this.resolveUrl(pathname)}`)
      && this.props.location.search.match(searchParams);
  }
  resolveUrl(url) {
    const root = this.props.root;
    return path.join(root, url);
  }
}

SettingsMenu.propTypes = {
  location: React.PropTypes.object,
};

export default SettingsMenu;



// WEBPACK FOOTER //
// ./src/frontend/layout/SettingsMenu.jsx